const steps = [
  {
    id: "selectEmploye",
    label: "Selección de personal",
    step: "start",
    number: 1,
  },
  {
    id: "formRequest",
    label: "Completar solicitud",
    step: "request",
    number: 2,
  },
  {
    id: "Agregar firmas",
    label: "Asignar firmas",
    step: "signature",
    number: 3,
  },
];

export default function StepProgress({ current, onChange }) {
  return (
    <div className="grid grid-cols-3 relative w-full max-w-[696px] mx-auto">
      {steps.map((step, index) => (
        <div
          key={index + step.id}
          className="relative z-10 flex flex-col items-center first:items-start last:items-end first:z-20 last:z-0 bullet-style"
          // onClick={() => onChange(step.step)}
        >
          <div
            className={`h-[0.2px] absolute top-[15px] ${
              current === step.step ? "bg-[#ffcc00FF]" : "bg-[#b1b2b5FF]"
            }
              ${index === 1 ? "left-[-218px]" : "hiiden"} 
              ${index === 1 || index === 2 ? "w-[348px]" : "hiiden"} `}
          />
          <div
            className={`size-[30px] flex items-center justify-center rounded-full transition-all z-10 border-2 bg-[#f7f9fdFF] ${
              current === step.step
                ? "shadow bg-yellow-500 border-black text-gray-800"
                : "border-gray-400 text-gray-500"
            }`}
          >
            <span className="size-[18px] relative text-center -top-0.5">
              {step.number}
            </span>
          </div>
          <span
            className={`mt-2 relative text-[16px] font-medium ${
              index === 0
                ? "left-[-63px]"
                : index === steps.length - 1
                  ? "right-[-36px]"
                  : ""
            }
            ${step.step === current ? "text-[#34445b] !font-bold" : "text-[#888686]"}`}
          >
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
}
